(() => {
  const SECTION_SELECTOR = '.custom-guides-download-form-v2';

  function initSection(section) {
    if (
      !section ||
      section.dataset.customGuidesDownloadFormV2Initialized === 'true'
    ) {
      return;
    }

    section.dataset.customGuidesDownloadFormV2Initialized = 'true';

    if (section.classList.contains('custom-guides-download-form-v2--animate')) {
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                section.classList.add('is-visible');
                observer.disconnect();
              }
            });
          },
          { threshold: 0.14 }
        );

        observer.observe(section);
      } else {
        section.classList.add('is-visible');
      }
    } else {
      section.classList.add('is-visible');
    }
  }

  function initAll(scope = document) {
    if (scope.matches && scope.matches(SECTION_SELECTOR)) {
      initSection(scope);
    }

    scope.querySelectorAll?.(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
